import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 45"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#i1273327896__a)\"><path fill=\"#42B883\" d=\"M31.397.752 25.5 10.836 19.603.752H0l25.5 43.67L51 .752z\"></path><path fill=\"#35495E\" d=\"M31.397.752 25.5 10.836 19.603.752H10.2l15.3 26.202L40.8.752z\"></path></g><defs><clipPath id=\"i1273327896__a\"><path fill=\"#fff\" d=\"M0 .5h51v44H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }